import { CameraKitSession, Lens } from "@snap/camera-kit";
import { DropdownInput, Option } from "@snapchat/snap-design-system";
import { CanvasContainer, Flexbox, FlexSection, Source } from "shared-resources";
import { controlPadding, sectionDropdown } from "./UseCase.styles";

interface UseCaseProps {
    sessionOutput: CameraKitSession["output"];
    availableSources: Source[];
    lenses: Lens[];
    onLensSelect: (lens: Lens) => Promise<void>;
    onSourceChange: (source: Source) => Promise<void>;
}

export const UseCase = ({ sessionOutput, availableSources, lenses, onLensSelect, onSourceChange }: UseCaseProps) => {
    return (
        <Flexbox flexDirection="column">
            <FlexSection justifyContent="flex-start" css={sectionDropdown}>
                <DropdownInput
                    disabled={!lenses.length}
                    placeholder="Choose a Lens..."
                    label="Lens"
                    data-testid="select-lens"
                    onChange={(lensId) => {
                        const lens = lenses.find((lens) => lens.id === lensId);
                        if (lens) onLensSelect(lens);
                    }}
                >
                    {lenses.map((lens: Lens) => (
                        <Option key={lens.id} value={lens.id}>
                            {lens.name}
                        </Option>
                    ))}
                </DropdownInput>

                <DropdownInput
                    css={controlPadding}
                    disabled={!availableSources.length}
                    placeholder="Choose a Camera..."
                    label="Camera"
                    onChange={(sourceIndex) => {
                        onSourceChange(availableSources[sourceIndex]);
                    }}
                    data-testid="sources-dropdown"
                >
                    {availableSources.map((sourceDevice, index) => {
                        const key = sourceDevice.sourceType === "device" ? sourceDevice.deviceId : sourceDevice.url;
                        return (
                            <Option key={key} value={index} data-testid={sourceDevice.label}>
                                {sourceDevice.label}
                            </Option>
                        );
                    })}
                </DropdownInput>
            </FlexSection>
            <FlexSection flexWrap="wrap">
                <CanvasContainer canvasOutput={sessionOutput.live} />
            </FlexSection>
        </Flexbox>
    );
};
